import React from 'react';
import { Scatter } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title
} from 'chart.js';

// Enregistre les composants nécessaires
ChartJS.register(
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title
);

const ClusterGraph = ({ clusterData }) => {
    if (!clusterData) return <div>No cluster data available</div>;

    const colors = [
        'rgba(31, 119, 180, 0.8)',  // bleu - cluster 1
        'rgba(255, 127, 14, 0.8)',  // orange - cluster 2
        'rgba(44, 160, 44, 0.8)',   // vert - cluster 3
        'rgba(214, 39, 40, 0.8)',   // rouge - cluster 4
        'rgba(148, 103, 189, 0.8)'  // violet - cluster 5
    ];

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                type: 'linear',
                position: 'bottom',
                title: {
                    display: true,
                    font: { size: 14 }
                },
                grid: {
                    display: true,
                    color: 'rgba(0, 0, 0, 0.1)'
                },
            },
            y: {
                type: 'linear',
                title: {
                    display: true,
                    font: { size: 14 }
                },
                grid: {
                    display: true,
                    color: 'rgba(0, 0, 0, 0.1)'
                },
            }
        },
        plugins: {
          legend: {
              position: 'right',
              labels: {
                  usePointStyle: true,
                  padding: 15,
                  font: { size: 12 }
              }
          },
          tooltip: {
              callbacks: {
                  label: (context) => {
                      // return `${context.dataset.label}: (${context.raw.x.toFixed(3)}, ${context.raw.y.toFixed(3)})`; // Affichage nom du cluster et coordonnées

                      // Récupérer l'index du point dans le dataset
                      const datasetIndex = context.datasetIndex;
                      const pointIndex = context.dataIndex;
                      
                      // Trouver l'index global du point
                      let globalIndex = 0;
                      for (let i = 0; i < datasetIndex; i++) {
                          globalIndex += context.chart.data.datasets[i].data.length;
                      }
                      globalIndex += pointIndex;

                      // Récupérer le nom de l'image
                      const imageName = clusterData.elements[globalIndex];
                      
                      return `${imageName}`;
                  }
              }
          }
        }
    };

    // Créer un mapping des anciens labels vers les nouveaux (1-5)
    const uniqueLabels = [...new Set(clusterData.clusters)].sort((a, b) => a - b);
    const labelMapping = {};
    uniqueLabels.forEach((label, index) => {
        labelMapping[label] = index + 1; // Nouveau label de 1 à 5
    });

    // Réorganiser les points avec les nouveaux labels
    const datasets = Array.from({ length: 5 }, (_, i) => i + 1).map(newLabel => {
        const oldLabel = Object.keys(labelMapping).find(key => labelMapping[key] === newLabel);
        const points = clusterData.points
            .filter((point, idx) => clusterData.clusters[idx] === Number(oldLabel))
            .map(point => ({
                x: point[0],
                y: point[1]
            }));

        return {
            label: `Cluster ${newLabel}`,
            data: points,
            backgroundColor: colors[newLabel - 1],
            pointStyle: 'circle',
            pointRadius: 6,
            pointHoverRadius: 8,
            showLine: false // Désactive les lignes
        };
    });

    return (
        <div style={{ height: '600px', width: '100%' }}>
            <Scatter 
                data={{ datasets }} 
                options={chartOptions} 
            />
        </div>
    );
};

export default ClusterGraph;